import { render, staticRenderFns } from "./TimelineCalendar.vue?vue&type=template&id=b3aca31a"
import script from "./TimelineCalendar.vue?vue&type=script&lang=js"
export * from "./TimelineCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports